export default __webpack_public_path__ + "static/t6-ce638377d02745d52f6b8eee9663bf16.webp";